/**
 * /billing/plans — Plans CRUD (PLATBILL-01, PLATBILL-02).
 *
 * Renders the card grid + Plan editor drawer; sits under the BillingHubLayout
 * outlet. Subscriptions and MRR live at sibling routes.
 */
import { createFileRoute } from "@tanstack/react-router";
import { PlansListScreen } from "../features/billing/PlansListScreen";

export const Route = createFileRoute("/_auth/billing/plans")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:billing.hub.tabs.plans" },
  },
  component: PlansListScreen,
});
